import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

var API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export var fetchTerms = createAsyncThunk(
  "terms/fetchTerms",
  async function (language, thunkApi) {
    try {
      if (!API_BASE_URL) {
        throw new Error("REACT_APP_API_BASE_URL is not configured");
      }

      var response = await fetch(API_BASE_URL + "/terms", {
        method: "GET",
        signal: thunkApi.signal,
        headers: {
          Accept: "application/json",
          "Accept-Language": language || "en",
        },
      });

      var contentType = response.headers.get("content-type");

      if (!contentType || contentType.indexOf("application/json") === -1) {
        throw new Error("The terms endpoint returned an invalid response");
      }

      var responseData = await response.json();

      if (!response.ok) {
        return thunkApi.rejectWithValue(
          responseData.message || "Unable to retrieve terms"
        );
      }

      return responseData.data;
    } catch (error) {
      return thunkApi.rejectWithValue(
        error.message || "Unable to connect to the server"
      );
    }
  }
);

var initialState = {
  terms: null,
  loading: false,
  error: "",
};

var termsSlice = createSlice({
  name: "terms",
  initialState: initialState,
  reducers: {},
  extraReducers: function (builder) {
    builder
      .addCase(fetchTerms.pending, function (state) {
        state.loading = true;
        state.error = "";
      })
      .addCase(fetchTerms.fulfilled, function (state, action) {
        state.loading = false;
        state.terms = action.payload;
      })
      .addCase(fetchTerms.rejected, function (state, action) {
        state.loading = false;
        state.error =
          action.payload || "Unable to retrieve terms";
      });
  },
});

export default termsSlice.reducer;